<script>
import Vue from 'vue';
import {MessageBus} from "@/service/message-bus";
import {ShoppingCartIcon} from "@/service/shopping-cart-icon";

export default Vue.extend({
    name: 'ShoppingCartProduct',
    mounted () {
        const shoppingCartIconElement = document.getElementById('shopping-cart-menu-item');
        if (shoppingCartIconElement != null) {
            const shoppingCartIcon = new ShoppingCartIcon(shoppingCartIconElement);

            // Listen for shoppingCart.updated event on the messageBus.
            MessageBus.getInstance().subscribe('shoppingCart.updated', (newShoppingCart) => {
                shoppingCartIcon.updateProductCount(newShoppingCart[0]);
            });
        }
    }
})
</script>
